import { CATALOG_TYPE_NOTVALIDFORSTRUCTURE } from '../types/catalogTypes';

export const NOT_VALID_FOR_STRUCURE_CATALOG = {
  catalogId: CATALOG_TYPE_NOTVALIDFORSTRUCTURE,
  catalogType: CATALOG_TYPE_NOTVALIDFORSTRUCTURE,
  catalogName: 'Not valid for structure Items',
};
